import {Component, HostListener} from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {filter} from 'rxjs/operators';
import {ApiAccessService} from './services/network/api-access.service';
import {RealtorPortalService} from './services/network/realtor-portal.service';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  isScrolled = false;
  sideNavOpen = false;
  isLoginPage = false;
  isLoggedIn = true;
  isHomePage = false;
  isWarrantyPage = false;

  myDebug = localStorage.getItem('login-info');
  unsecuredUrls = [
    '/log-in',
    '/log-out',
    '/reset-password',
    '/register',
    '/federated-login',
    '/warranty-link'
  ];

  enteringAnimation = false;

  constructor(private router: Router, private route: ActivatedRoute,
              private realtorPortalService: RealtorPortalService) {
    this.isHomePage = router.url === '/home' || router.url === '/';
    this.router.events.filter(event => event instanceof NavigationEnd)
        .subscribe(event => {


          const myEvent: any = event;

          this.isLoginPage = myEvent.url === '/log-in';
          this.isHomePage = myEvent.url === '/home' || myEvent.url === '/';


          if (myEvent && myEvent.url && myEvent.url.indexOf('#') === -1) {
            this.enteringAnimation = true;
          }

          setTimeout(() => this.enteringAnimation = false, 750);

          this.isLoggedIn = ApiAccessService.isLoggedIn;


          if (this.isLoginPage) {
            // document.getElementsByTagName('body')[0].classList.add('login-bg');
          } else {
            // document.getElementsByTagName('body')[0].classList.remove(
            //    'login-bg');
          }

          if (myEvent.url.indexOf('/warranty-link') === 0) {
            myEvent.url = '/warranty-link';
            this.isWarrantyPage = true;
            document.body.style.backgroundImage = '';
          } else {
            document.body.style.backgroundImage = 'url(https://common.oneguardhomewarranty.com/cdn/images/og-bg.png)';
          }

          if (!ApiAccessService.isLoggedIn &&
              this.unsecuredUrls.indexOf(myEvent.url) === -1) {
            this.router.navigateByUrl('/log-in');
          } else if (ApiAccessService.isLoggedIn &&
                     !ApiAccessService.fromFederatedLogin &&
                     this.unsecuredUrls.indexOf(myEvent.url) === -1) {
            // realtorPortalService.authenticate(ApiAccessService.userName,
            //                                   ApiAccessService.password)
            //     .then(result => {
            //       if (!result) {
            //         this.router.navigateByUrl('/log-in');
            //       }
            //     });
          }

          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        });

    if (ApiAccessService.isLoggedIn && !ApiAccessService.fromFederatedLogin) {
      realtorPortalService.authenticateUser({
        UserName: ApiAccessService.userName,
        Password: ApiAccessService.password
      }).then(results => {
            if (!results && !ApiAccessService.fromFederatedLogin) {
              router.navigateByUrl('/log-in');
            }
          });
    }
  }

  goBack() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    window.history.back();
  }

  get showWhite() {
    return this.isScrolled || this.isLoginPage ||
           (this.isHomePage );
  }

  get isClear() {
    return this.isHomePage  && window.scrollY === 0;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 0;
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    // ApiAccessService.clearLoginInfo();
  }
}
